import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'xm-spark';
import useFeatureToggle from 'hooks/useFeatureToggle';
import SmsComplianceDialog from 'Application/SmsComplianceDialog';

import styles from './Footer.module.scss';

export default function Footer() {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const isUserComplianceEnabled = useFeatureToggle('USER_COMPLIANCE');
  return (
    <footer id="footer" className={styles.footer}>
      <ul>
        <li>
          <a
            href="http://www.xmatters.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>&copy; </span>
            <FormattedMessage id="POWERED_BY_XMATTERS" />
          </a>
        </li>
        <li>
          <a
            href="http://www.xmatters.com/policy/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="PRIVACY_POLICY" />
          </a>
        </li>
        {isUserComplianceEnabled && (
          <li>
            <Button
              color="tertiary"
              variant="small"
              onClick={() => setDialogOpen(true)}
            >
              <FormattedMessage id="ABOUT" />
            </Button>
          </li>
        )}
      </ul>
      {isDialogOpen && (
        <SmsComplianceDialog onClose={() => setDialogOpen(false)} />
      )}
    </footer>
  );
}
